/* Le Shop 17 x Fitzu : animation du telephone de la cabine d'essayage.
   Une instance par bandeau .ls17-fz present sur la page.
   Libelles de generation bilingues : la langue vient du <html lang>. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Ecran -> etape mise en avant, et duree de chaque ecran (ms) */
  var SIDE = [0, 0, 1, 2, 3, 3];
  var DURS = [1900, 1700, 2900, 2000, 4400, 3300];
  var LOOP_PAUSE = 1100;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var LABELS = EN
    ? ['Analysing the photo', 'Preparing the setting', 'Hair', 'Make-up', 'Styling', 'Generating the look', 'Finishing touches']
    : ['Analyse de la photo', 'Preparation du decor', 'Coiffure', 'Maquillage', 'Stylisme', 'Generation du look', 'Finalisation'];

  function init(root) {
    if (root.dataset.ls17Init) return;
    root.dataset.ls17Init = '1';

    var flow = root.querySelector('.ls17-fz__flow');
    if (!flow) return;
    var screens = flow.querySelectorAll('.ls17-fz__scr');
    var steps = root.querySelectorAll('.ls17-fz__step');
    var dots = root.querySelectorAll('.ls17-fz__dots i');
    if (!screens.length) return;

    var i = 0, timer = null, gen = null, playing = false;

    function clearGen() { if (gen) { clearInterval(gen); gen = null; } }

    /* Rejoue les animations CSS de l'ecran que l'on quitte */
    function resetAnim(scr) {
      if (!scr || reduce) return;
      var nodes = scr.querySelectorAll('.fzup-drop,.fzup-spin,.fzup-img,.fzup-ok,.fzsweep,.fzbarfill,.fzresimg,.fzresbar');
      Array.prototype.forEach.call(nodes, function (el) {
        el.style.animation = 'none';
        el.style.transition = 'none';
        void el.offsetWidth;
        el.style.animation = '';
        el.style.transition = '';
      });
    }

    function runGen(scr) {
      var lab = scr.querySelector('.fzlabel'), cnt = scr.querySelector('.fzcount'), k = 0;
      if (!lab || !cnt) return;
      lab.textContent = LABELS[0];
      cnt.textContent = '1/7';
      clearGen();
      gen = setInterval(function () {
        k++;
        if (k >= LABELS.length) { clearGen(); return; }
        lab.textContent = LABELS[k];
        cnt.textContent = (k + 1) + '/7';
      }, 600);
    }

    function show(n) {
      if (i !== n && screens[i]) resetAnim(screens[i]);
      i = n;
      Array.prototype.forEach.call(screens, function (s, k) { s.classList.toggle('on', k === n); });
      Array.prototype.forEach.call(steps, function (s, k) { s.classList.toggle('on', k === SIDE[n]); });
      Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('on', k === SIDE[n]); });
      clearGen();
      if (screens[n].querySelector('.fzsweep')) runGen(screens[n]);
    }

    function scheduleNext() {
      if (!playing) return;
      var wait = DURS[i];
      if (i === screens.length - 1) wait += LOOP_PAUSE;
      timer = setTimeout(advance, wait);
    }
    function advance() {
      if (!playing) return;
      show((i + 1) % screens.length);
      scheduleNext();
    }
    function play() {
      if (reduce) { show(screens.length - 1); return; }
      playing = true;
      clearTimeout(timer); timer = null;
      scheduleNext();
    }
    function stop() { playing = false; clearTimeout(timer); timer = null; clearGen(); }

    show(0);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? play() : stop(); });
      }, { threshold: 0.25 }).observe(flow);
    } else {
      play();
    }
  }

  function boot() {
    document.querySelectorAll('.ls17-fz').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Editeur de theme : la section est rechargee sans reload de page */
  document.addEventListener('shopify:section:load', boot);
})();
